import { render, staticRenderFns } from "./AtendimentoEnfermagemPainel.vue?vue&type=template&id=25ad4e50&"
import script from "./AtendimentoEnfermagemPainel.vue?vue&type=script&lang=js&"
export * from "./AtendimentoEnfermagemPainel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports